<template>
  <div id="resetPassword" class="column is-full-mobile is-three-fifths-tablet is-4-desktop is-4-widescreen is-4-fullhd is-offset-one-fifth-tablet is-offset-4-desktop is-offset-4-widescreen is-offset-4-fullhd">
    <div class="box">
      <div class="columns">
        <div class="column is-full">
          <img src="../assets/images/logo-pneudart-blue.svg" alt="Pneu-Dart" class="column is-10-mobile is-offset-1-mobile is-8-tablet is-offset-2-tablet is-inline-block">
          <p class="is-size-6 has-text-primary has-text-centered">Channel Partner Product Request System</p>
        </div>
      </div>
      <div class="columns py-4">
        <div class="column is-full">
          <h4 class="title is-4 has-text-centered py-2">Reset Password</h4>
          <form v-on:submit.prevent="resetPassword">
            <b-field label="Email / Username" horizontal
              :type="getFieldTypesFromValidationPath('email')"
              :message="getFieldMessages('email')">
              <b-input type="email" name="email" v-model.trim="$v.email.$model" :loading="$wait.is(resetPasswordLoader)" :disabled="$wait.any" @input.native="set"></b-input>
            </b-field>
            <b-field label="New Password" horizontal
              :type="getFieldTypesFromValidationPath('password')"
              :message="getFieldMessages('password')">
              <b-input type="password" name="password" v-model.trim="$v.password.$model" :loading="$wait.is(resetPasswordLoader)" :disabled="$wait.any" @input.native="setPassword" password-reveal></b-input>
            </b-field>
            <b-field label="Confirm New Password" horizontal
              :type="getFieldTypesFromValidationPath('password_confirmation')"
              :message="getFieldMessages('password_confirmation')">
              <b-input type="password" name="password_confirmation" v-model.trim="$v.password_confirmation.$model" :loading="$wait.is(resetPasswordLoader)" :disabled="$wait.any" @input.native="setPasswordConfirmation" password-reveal></b-input>
            </b-field>
            <b-field label="" horizontal>
              <b-button type="is-primary" @click="submitResetPassword" :loading="$wait.is(resetPasswordLoader)" :disabled="! isResetPasswordSubmittable"><i class="sl-key-2"></i> Reset Password</b-button>
            </b-field>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import { validations, messages } from '@/plugins/vuelidate/validations/reset-password'

export default {
  data: function() {
    return {
      token: '',
      email: '',
      password: '',
      password_confirmation: '',
      messages: messages,
      apiValidationErrors: {}
    }
  },
  computed: {
    passwordResetRedirect() {
      return '/login'
    },
    resetPasswordLoader() {
      return 'resetting password'
    },
    resetPasswordPathSubset() {
      return ['email', 'password', 'password_confirmation']
    },
    resetPasswordPropertySubset() {
      return this.getPropertiesFromPaths(this.resetPasswordPathSubset)
    },
    isResetPasswordSubmittable() {
      return (! this.isSaving && this.isResetPasswordDirty && ! this.resetPasswordHasErrors)
    },
    isResetPasswordDirty() {
      return this.$v.email.$dirty || this.$v.password.$dirty || this.$v.password_confirmation.$dirty 
    },
    isSaving() {
      return this.$wait.any
    },
    resetPasswordHasErrors() {
      return this.$v.$error
    }
  },
  validations: validations,
  methods: {
    ...mapActions([
      'resetPassword'
    ]),
    set(e) {
      this.clearApiValidationFailures(e.target.name)
    },
    setPassword (e) {
      this.clearApiValidationFailures(e.target.name)
      this.$v.password_confirmation.$touch()
    },
    setPasswordConfirmation (e) {
      this.clearApiValidationFailures(e.target.name)
      this.$v.password.$touch()
    },
    failedApiValidation(property) {
      return this.apiValidationErrors.hasOwnProperty(property)
    },
    clearApiValidationFailures(property) {
      if (this.apiValidationErrors.hasOwnProperty(property)) {
        delete this.apiValidationErrors[property]
      }
    },
    getFieldTypesFromValidationPath(validationPath) {
      return {
        'is-danger': eval(`this.$v.${validationPath}.$error`)
      }
    },
    getFieldMessages(validationPath) {
      let validationPathArray = validationPath.split('.')
      return {
        ...this.getFieldMessagesFromValidationPath(validationPath),
        ...this.getFieldMessagesFromFailedApiValidation(
          validationPathArray.pop()
        )
      }
    },
    getFieldMessagesFromFailedApiValidation(property) {
      let fieldMessages = {}
      if (this.apiValidationErrors.hasOwnProperty(property)) {
        fieldMessages[this.apiValidationErrors[property]] = true
      }
      return fieldMessages
    },
    getFieldMessagesFromValidationPath(validationPath) {
      let validationPathArray = validationPath.split('.')
      let messages = this.messages

      while (validationPathArray.length) {
        messages = messages[validationPathArray.shift()]
      }

      let fieldMessages = {}

      for (const validation in messages) {
        fieldMessages[messages[validation]] = eval(
          `this.$v.${validationPath}.$error && ! this.$v.${validationPath}.${validation}`
        )
      }

      return fieldMessages
    },
    isValid(pathSubset) {
      let invalid = false
      for (const path of pathSubset) {
        eval(`this.$v.${path}.$touch()`)
        invalid = invalid || eval(`this.$v.${path}.$invalid`)
      }
      if (invalid) {
        this.$buefy.dialog.alert({
          type: 'is-danger',
          message: 'Please fix the indicated fields'
        })
        return
      }
      return true
    },
    validate(pathSubset) {
      if (!this.isValid(pathSubset)) {
        this.$buefy.dialog.alert({
          type: 'is-danger',
          message: 'Please fix the indicated fields'
        })
        return
      }
      return true
    },
    async submitResetPassword() {
      if (this.validate(this.resetPasswordPathSubset)) {
        this.$wait.start(this.resetPasswordLoader)
        try {
          await this.resetPassword({
            token: this.$route.params.token,
            email: this.email,
            password: this.password,
            password_confirmation: this.password_confirmation
          })
          this.email = ''
          this.password = ''
          this.password_confirmation = ''
          this.$v.$reset()
          this.$buefy.toast.open({
            message: 'Your password has been updated. You will now be redirected to login.',
            type: 'is-success',
            position: 'is-top',
            duration: 5000
          })
          this.$router.push(this.passwordResetRedirect)
          this.$wait.end(this.resetPasswordLoader)
        } catch (error) {
          switch (error.response.status) {
            case 422:
              this.apiValidationErrors = error.response.data.errors
              if (message) {
                this.$buefy.dialog.alert({
                  type: 'is-danger',
                  message: 'Unable to reset password. Please try again.'
                })
              }
              break
            default:
              console.log(error)
          }
          return Promise.reject(error)
        }
      }
    }
  }
}
</script>